import Dropdown from 'react-bootstrap/Dropdown';
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'react-bootstrap';
import { RaaRoles } from '../../../../../../utility/SecurityRules';
import HasRolePrivileges from '../../../../../highorder/HasRolePrivileges';
import styles from './AdvancedSearchListButtonGroup.module.css';

const AdvancedSearchListButtonGroup = ({
  isEditingSavedSearch,
  handleSaveEdited,
  handleSaveAs,
  handleDiscardSavedSearchChanges,
  handleClearSearch,
}) => {
  if (isEditingSavedSearch) {
    return (
      <span style={{ marginTop: '1px', display: 'flex' }}>
        <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
          <div className="mr-2 align-self-center">
            <Dropdown
              as={ButtonGroup}
              data-testid="save-existing-dropdown"
              id="save-existing-dropdown"
            >
              <button
                type="button"
                className={`${styles.buttonCustom} btn btn-sm btn-secondary px-1 py-0`}
                onClick={handleSaveEdited}
              >
                Save
              </button>
              <Dropdown.Toggle
                split
                variant="secondary"
                size="sm"
                className={`${styles.dropDownCustom} btn btn-sm btn-secondary px-1 py-0`}
              />
              <Dropdown.Menu>
                <Dropdown.Item
                  eventKey="1"
                  data-testid="save-edited"
                  onClick={handleSaveAs}
                >
                  Save As
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </HasRolePrivileges>
        <div className="mr-2 align-self-center">
          <Dropdown as={ButtonGroup} id="discard-changes-dropdown">
            <button
              type="button"
              className={`${styles.buttonCustom} btn btn-sm btn-secondary px-1 py-0`}
              onClick={handleDiscardSavedSearchChanges}
            >
              Discard Changes
            </button>
            <Dropdown.Toggle
              split
              variant="secondary"
              size="sm"
              className={`${styles.dropDownCustom} btn btn-sm btn-secondary px-1 py-0`}
            />
            <Dropdown.Menu>
              <Dropdown.Item eventKey="1" onClick={handleClearSearch}>
                Clear Search
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </span>
    );
  }

  /* istanbul ignore next */
  return (
    <span style={{ marginTop: '6px' }}>
      <HasRolePrivileges targetRoleList={[RaaRoles.ADMIN, RaaRoles.MANAGER]}>
        <button
          type="button"
          aria-label="save as"
          style={{
            alignSelf: 'center',
            fontSize: '12px',
            fontWeight: 'bold',
            borderColor: '#a3a9ae',
            backgroundColor: '#a3a9ae',
          }}
          data-testid="save-new-search"
          onClick={handleSaveAs}
          className="btn btn-secondary px-1 py-0 mr-2"
        >
          Save As
        </button>
      </HasRolePrivileges>
      <button
        type="button"
        aria-label="clear search"
        data-testid="clear-search-btn"
        style={{
          alignSelf: 'center',
          fontSize: '12px',
          fontWeight: 'bold',
          borderColor: '#a3a9ae',
          backgroundColor: '#a3a9ae',
        }}
        onClick={handleClearSearch}
        className="btn btn-secondary px-1 py-0"
      >
        Clear Search
      </button>
    </span>
  );
};
AdvancedSearchListButtonGroup.propTypes = {
  isEditingSavedSearch: PropTypes.bool.isRequired,
  handleSaveEdited: PropTypes.func.isRequired,
  handleSaveAs: PropTypes.func.isRequired,
  handleDiscardSavedSearchChanges: PropTypes.func.isRequired,
  handleClearSearch: PropTypes.func.isRequired,
};
export default AdvancedSearchListButtonGroup;
